export default __webpack_public_path__ + "static/media/baseline-battery_full-24px.ccfc4ce8.svg";